import styled from 'styled-components';

import { Spacer } from '@ontruck/orc';
import StyledFloatingButton from './StyledFloatingButton';

const StyledShipmentBox = styled(Spacer).attrs(() => ({ p: 'M' }))`
  position: relative;
  background-color: var(--whiteCaniche);
  border-radius: 4px;
  border: 1px solid var(--greyMouse);

  &:hover {
    ${StyledFloatingButton} {
      display: block;
    }
  }
`;

export default StyledShipmentBox;
